var map = {
	"./brand-babel.svg": "4f5e",
	"./brand-bootstrap-vue.svg": "7494",
	"./brand-bootstrap.svg": "3bed",
	"./brand-eslint.svg": "da1f",
	"./brand-fontawesome.svg": "826a",
	"./brand-git.svg": "ab8e",
	"./brand-gitlab.svg": "6a7a",
	"./brand-nodejs.svg": "b04d",
	"./brand-npm.svg": "763c",
	"./brand-sass.svg": "15f4",
	"./brand-vuejs.svg": "061d",
	"./brand-webpack.svg": "2db2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55ec";